module.exports = __webpack_public_path__ + "img/logo.7bc6e0da.png";